import { post, get, webApi } from '../utils/http';
import queryString from 'query-string';

const MOCK_ARTS_DISTRIBUTION = {
  axes: [
    {
      id: 1,
      key: 'A',
      name: 'Asertividad',
      profiles: [
        {
          id: 5,
          name: 'Proactivo',
          x: 86.49,
          y: 73.68,
          total: 9,
          persons: [
            'Flo Melia',
            'Jacob S',
            'Kylie Miñon',
            'Mariel Greco',
            'mpd 2710',
          ],
        },
        {
          id: 3,
          name: 'Definido',
          x: 78.94,
          y: 81.2,
          total: 3,
          persons: [
            'Gloria Gaynor',
            'Marcos Arizmendi',
            'Ricãrdö Estébän',
            'Ricãrdö Estébän',
          ],
        },
        {
          id: 4,
          name: 'Orientado a objetivos',
          x: 54,
          y: 57.5,
          total: 2,
          persons: ['Daniela Escobar', 'Jacinto Lanao'],
        },
        {
          id: 26,
          name: 'Indagador',
          x: 86.49,
          y: 63.7,
          total: 2,
          persons: ['Natalia Pino', 'Patty S'],
        },
        {
          id: 6,
          name: 'Orientado a resolver tareas',
          x: 51,
          y: 65.76,
          total: 1,
          persons: ['Emilia González'],
        },
        {
          id: 1,
          name: 'Dominador',
          x: 72.76,
          y: 92.18,
          total: 1,
          persons: ['Ares Ras', 'Ares Ras'],
        },
        {
          id: 2,
          name: 'Activo',
          x: 74.37,
          y: 85.97,
          total: 1,
          persons: ['Lenny Naw'],
        },
      ],
      totalByAxis: 19,
    },
    {
      id: 2,
      key: 'S',
      name: 'Sociabilidad',
      profiles: [
        {
          id: 9,
          name: 'Transformador',
          x: 72.93,
          y: 34.32,
          total: 8,
          persons: [
            'Aurora Morales',
            'Coti Soiba',
            'Test perfil Autorregulado',
            'Valentina Allejo',
            'Valentina Allejo',
          ],
        },
        {
          id: 7,
          name: 'De intuición',
          x: 85.44,
          y: 37.53,
          total: 4,
          persons: [
            'Andres Garcia',
            'Jonatan Barjuch',
            'Sofia Sanchez',
            'Sofia Sanchez',
            'Zusetty Alejandra Oyola Davila',
          ],
        },
        {
          id: 10,
          name: 'Mediador',
          x: 78.92,
          y: 28.32,
          total: 3,
          persons: ['Marcio Santos', 'Marisol Fernandez', 'Ryet Moore'],
        },
        {
          id: 8,
          name: 'De influencia',
          x: 57.84,
          y: 43.85,
          total: 2,
          persons: ['ASD asd', 'Valencia NWM hml'],
        },
        {
          id: 11,
          name: 'Seductor/Encantador',
          x: 78.92,
          y: 20.65,
          total: 2,
          persons: ['Bella Moore', 'Chris Morgan'],
        },
        {
          id: 13,
          name: 'Cordial',
          x: 72.93,
          y: 6.42,
          total: 2,
          persons: ['Lila Nawii', 'Trish Main', 'Trish Main'],
        },
        {
          id: 12,
          name: 'De promoción',
          x: 72.93,
          y: 16.84,
          total: 2,
          persons: ['Luna Diaz', 'Perfil Estrategico'],
        },
      ],
      totalByAxis: 23,
    },
    {
      id: 3,
      key: 'T',
      name: 'Tolerancia',
      profiles: [
        {
          id: 15,
          name: 'Tranquilo',
          x: 9.74,
          y: 21.17,
          total: 24,
          persons: [
            'Denis Ferreira',
            'Denis Ferreira',
            'Kimberly Morroni',
            'Kimberly Morroni',
            'Vera M',
          ],
        },
        {
          id: 17,
          name: 'Político',
          x: 42.92,
          y: 1.88,
          total: 13,
          persons: [
            'Ciro P',
            'Greta Fernandez',
            'Greta Fernandez',
            'Salvador Martinez',
            'Toro P',
          ],
        },
        {
          id: 18,
          name: 'De personas',
          x: 38.82,
          y: 5.84,
          total: 3,
          persons: ['Bonnie P.', 'Marcos Ramos', 'Perfil Empatico'],
        },
        {
          id: 19,
          name: 'Amistoso',
          x: 34.63,
          y: 10.00,
          total: 2,
          persons: ['Nuevo HML', 'Tiara Mesa', 'Tiara Mesa'],
        },
        {
          id: 16,
          name: 'Asistente',
          x: 9.74,
          y: 14.78,
          total: 2,
          persons: ['Flora Nora hml', 'Hayden Smith', 'Hayden Smith'],
        },
        {
          id: 14,
          name: 'De argumentos',
          x: 46.44,
          y: 46.18,
          total: 2,
          persons: ['Pablo Estilo', 'Permisos De Dash'],
        },
        {
          id: 20,
          name: 'De análisis',
          x: 27.89,
          y: 40.4,
          total: 1,
          persons: ['Jair Tarquino', 'Jair Tarquino'],
        },
      ],
      totalByAxis: 47,
    },
    {
      id: 4,
      key: 'R',
      name: 'Reglas',
      profiles: [
        {
          id: 23,
          name: 'Exacto',
          x: 21.95,
          y: 76.34,
          total: 2,
          persons: ['Capitan M', 'juego01 hml'],
        },
        {
          id: 25,
          name: 'Receptivo',
          x: 39.67,
          y: 69.72,
          total: 1,
          persons: ['Alberto Bajo Dasca'],
        },
        {
          id: 24,
          name: 'Apegado a reglas',
          x: 34.44,
          y: 99.25,
          total: 1,
          persons: ['Lorena Varon'],
        },
        {
          id: 22,
          name: 'Desconfiado',
          x: 2.83,
          y: 65.68,
          total: 1,
          persons: ['Mario Benedetti'],
        },
        {
          id: 21,
          name: 'Riguroso',
          x: 37.04,
          y: 60.97,
          total: 1,
          persons: ['Juliana Gaviria'],
        },
      ],
      totalByAxis: 6,
    },
  ],
  grandTotal: 95,
};

export const services = {
  getDashboardReportAge: (filter) =>
    get(
      webApi +
        `api/results/age-distribution?lang=${localStorage.getItem(
          'language',
        )}&${queryString.stringify(filter)}`,
    ),
  getDashboardReportProfile: (filter) =>
    get(
      webApi +
        `api/results/profiles-distribution?lang=${localStorage.getItem(
          'language',
        )}&${queryString.stringify(filter)}`,
    ),
  getDashboardReportProfileGender: (time, filter) =>
    post(
      webApi +
        `api/stats/profile_gender/${time.toUpperCase()}/?lang=${localStorage.getItem(
          'language',
        )}`,
      // { ...filter },
    ),
  getDashboardReportCity: (filter) =>
    get(
      webApi +
        `api/results/demographic-distribution?lang=${localStorage.getItem(
          'language',
        )}&${queryString.stringify(filter)}`,
    ),
  getDashboardArtsDistribution: (filter) =>
    get(
      webApi +
        `api/results/arts-distribution?lang=${localStorage.getItem(
          'language',
        )}&${queryString.stringify(filter)}`,
    ),
  getLastMonth: () => get(webApi + 'api/results/last-month'),
};
